type SelectorType = `${'.' | '#'}${string}`

/**
 * Скролл-переход к блоку по селектору
 * @param selector - селектор документа
 * @param options - опции скролла
 */
export const scrollToBlock = (
  selector: SelectorType,
  options: ScrollIntoViewOptions = {
    behavior: 'smooth',
    block: 'center',
  },
) => {
  const element = document.querySelector(selector)

  if (!element) {
    console.warn(`Элемент с селектором ${selector} не найден.`)

    return
  }

  element.scrollIntoView(options)
}
